/**
 * Created by jiachenpan on 16/11/18.
 */

/* export function isvalidUsername (str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}
*/
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

export function isexcelempty(exlength) {
  return exlength > 0
}
export function validateSameName(rule, value, callback) {
  for (var names in this.tasknameList) {
    if (value === this.tasknameList[names].TaskName) {
      return callback(new Error('You have used this name before.'))
    }
  }
  callback()
}

export const Validate = {
  name: /^[a-zA-Z0-9_]+$/, // 字母数字或下划线,
  url: /^(http|https|ftp):\/\//,
  number: /^\d+$/
}

// form表单校验不能为空处理
export function formatRules(rules) {
  for (const i in rules) {
    ;(rules[i]).forEach((v) => {
      if (v.required && !v.pattern && !v.validator) {
        v.validator = (rule, value, callback) => {
          if (
            (Array.isArray(value) && value.length === 0) ||
            value === undefined ||
            value === null ||
            (typeof value === 'string' && value.trim() === '')
          ) {
            callback(new Error()) // 取Message
            return
          }
          callback()
        }
      }
    })
  }
  return rules
}

export function emptyValidator (rule, value, callback) {
  if (value.trim() === '') {
    callback(new Error())
  } else {
    callback()
  }
}



// WEBPACK FOOTER //
// ./src/utils/validate.js